import { createGetPropGetter } from '@/store/utils';

export default {
  loadingValidation: createGetPropGetter('loadingValidation', false),
  spEmployeeBeforeEdit: createGetPropGetter('spEmployeeBeforeEdit', {}),
  currentSPEmployee: createGetPropGetter('currentSPEmployee', {}),
  chosenSPEmployeeId: createGetPropGetter('chosenSPEmployeeId', null),
  serviceProvidersOfCompanyList: createGetPropGetter('serviceProvidersOfCompanyList', []),
  serviceProviderFreelancerProfileDetails: createGetPropGetter('serviceProviderFreelancerProfileDetails', {}),
  serviceProviderCompanyProfileDetails: createGetPropGetter('serviceProviderCompanyProfileDetails', {}),
  serviceProviderWorkerProfileDetails: createGetPropGetter('serviceProviderWorkerProfileDetails', {}),
  companyCustomerProfileDetails: createGetPropGetter('companyCustomerProfileDetails', {}),
  customerProfileDetails: createGetPropGetter('customerProfileDetails', {}),
  serviceProviderFreelancerRecommendationsContacts: state => {
    if (!state.serviceProviderFreelancerProfileDetails.workerProfile.recommendationsContacts ||
      !state.serviceProviderFreelancerProfileDetails.workerProfile.recommendationsContacts.length) {
      return ['', ''];
    }
    return state.serviceProviderFreelancerProfileDetails.workerProfile.recommendationsContacts;
  },
  serviceProviderFreelancerServices: state => {
    if (!state.serviceProviderFreelancerProfileDetails.workerProfile.services.length) {
      return [];
    }
    return state.serviceProviderFreelancerProfileDetails.workerProfile.services.map(service => service.shortName);
  },
  serviceProviderCompanyServices: state => {
    if (!state.serviceProviderCompanyProfileDetails.services.length) {
      return [];
    }
    return state.serviceProviderCompanyProfileDetails.services.map(service => service.shortName);
  },
  companyCustomerFullIndustriesOptions: createGetPropGetter('companyCustomerFullIndustriesOptions', []),
  companyCustomerFullRegulationsOptions: createGetPropGetter('companyCustomerFullRegulationsOptions', []),
  companyCustomerFullRegionsOptions: createGetPropGetter('companyCustomerFullRegionsOptions', []),
  serviceProviderCompanyFullRegionsOptions: createGetPropGetter('serviceProviderCompanyFullRegionsOptions', []),
  serviceProviderCompanyFullServicesOptions: createGetPropGetter('serviceProviderCompanyFullServicesOptions', []),
  isServiceProvider: createGetPropGetter('isServiceProvider', false),
  advisedActions: createGetPropGetter('advisedActions', []),
  domains: createGetPropGetter('domains', []),
  domainsListOptions: createGetPropGetter('domainsListOptions', {}),
  domainListSort(state, { domainsListOptions = {} }) {
    return domainsListOptions.sort || {};
  },
  featureToggles: createGetPropGetter('featureToggles', {}),
  licenseData: createGetPropGetter('licenseData', null),
  // License-based module checks — use these instead of featureToggles
  licenseModules(state) {
    return state.licenseData?.permissions?.modules || [];
  },
  hasLicenseModule: state => module => {
    // Check tenant-level modules first
    if ((state.licenseData?.permissions?.modules || []).includes(module)) return true;
    // MSSP: also check org-level licenses
    if (state.licenseData?.isMssp === true) {
      const orgs = state.licenseData?.organizations || [];
      return orgs.some(org => (org.licenses || []).some(lic => !lic.isExpired && lic.skuDetails?.module === module));
    }
    return false;
  },
  whiteLabelingConfig(state) {
    const allLicenses = state.licenseData?.allLicenses || [];
    const wlRow = allLicenses.find(
      l => !l.isExpired && (l.skus || []).includes('CYN-WHITE-LABELING'),
    );
    return {
      domain: wlRow?.rawLicense?.whiteLabeling || null,
      displayName: wlRow?.rawLicense?.whiteLabelingDisplayName || null,
    };
  },
  isMsspLicense(state) {
    // MSSP is carried by a dedicated CYN-MSSP config row, surfaced by the backend
    // as `isMssp` (and reflected in permissions.modules) — not the base row's
    // licenseType, which stays 'regular' for MSSP tenants.
    return state.licenseData?.isMssp === true ||
      (state.licenseData?.permissions?.modules || []).includes('mssp');
  },
  isLicenseExpired(state) {
    return state.licenseData?.permissions?.isExpired === true;
  },
  companyData: createGetPropGetter('companyData', {}),
  scan_data: createGetPropGetter('scan_data', []),
  scanDataListOptions: createGetPropGetter('scanDataListOptions', {}),
  scanDataListSort(state, { scanDataListOptions = {} }) {
    return scanDataListOptions.sort || {};
  },
  users: createGetPropGetter('users', []),
  userListOptions: createGetPropGetter('userListOptions', {}),
  userListSort(state, { userListOptions = {} }) {
    return userListOptions.sort || {};
  },
  tenantUsers: createGetPropGetter('tenantUsers', []),
  pendingUsers: createGetPropGetter('pendingUsers', []),
  tenantUsersListOptions: createGetPropGetter('tenantUsersListOptions', {}),
  tenantUsersListSort(state, { tenantUsersListOptions = {} }) {
    return tenantUsersListOptions.sort || {};
  },
  workers: createGetPropGetter('workers', []),
  workerListOptions: createGetPropGetter('workerListOptions', {}),
  workerListSort(state, { workerListOptions = {} }) {
    return workerListOptions.sort || {};
  },
  workerDetails: createGetPropGetter('workerDetails', {}),
  systemSettings: createGetPropGetter('systemSettings', {}),
  disableDeleteUserButton: createGetPropGetter('disableDeleteUserButton', []),
  deleteUserLoading: createGetPropGetter('deleteUserLoading', false),
  userDetailsForEdit: createGetPropGetter('userDetailsForEdit', {}),
  newUserPassword: createGetPropGetter('newUserPassword', ''),
};
